var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrowFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.85227 1.9106L2.14844 0.617187L7.00035 5.46543L11.8523 0.617187L13.1484 1.91427L8.29652 6.75884C7.95272 7.10254 7.48649 7.29562 7.00035 7.29562C6.51422 7.29562 6.04799 7.10254 5.70419 6.75884L0.85227 1.9106Z",
    fill: "#331400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowFilled);
export default __webpack_public_path__ + "static/media/downArrowFilled.44889706138b4a5901f4669aff52c5b5.svg";
export { ForwardRef as ReactComponent };